import script from "./MaintenanceListView.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenanceListView.vue?vue&type=script&setup=true&lang=js"

import "./MaintenanceListView.vue?vue&type=style&index=0&id=65d8ea88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d8ea88"]])

export default __exports__